<div class="silo-bag-selector">
  <h4>{{ titleKey|translate }}</h4>

  <p class="text-muted" *ngIf="!readonly" [innerHtml]="helpKey|translate: {
    required: orderQuantity|number:'1.0-0',
    coverage: requiredCoverage|number:'1.0-2'
  }"></p>
  <p class="text-muted" *ngIf="readonly">{{ committedHelpKey|translate }}</p>

  <div class="alert silo-bag-negotiable" *ngIf="showsNegotiableToggle">
    <i class="material-symbols-rounded">visibility_lock</i>
    <div>
      <div class="checkbox">
        <label>
          <input type="checkbox"
            [checked]="negotiable"
            [disabled]="disabled"
            (change)="toggleNegotiable()">
          <b>{{ 'SILO_BAGS.NEGOTIABLE_LABEL'|translate }}</b>
        </label>
      </div>
      <div class="silo-bag-negotiable-help">{{ 'SILO_BAGS.NEGOTIABLE_HELP'|translate }}</div>
    </div>
  </div>

  <div class="alert alert-info silo-bag-locked" *ngIf="lockedNoticeKey as lockedKey">
    <i class="material-symbols-rounded">lock</i> {{ lockedKey|translate }}
  </div>

  <div class="loading" *ngIf="loading">
    <spinner message="{{ 'GLOBAL.LOADING'|translate }}"></spinner>
  </div>

  <div *ngIf="loadError" class="alert alert-danger">
    {{ 'SILO_BAGS.LOAD_ERROR'|translate }}
  </div>

  <div *ngIf="missingCredentials" class="alert alert-warning">
    <span [innerHtml]="missingStockMessageKey|translate"></span>
    <a *ngIf="showIntegrationsLink" [routerLink]="integrationsLink">{{ 'SILO_BAGS.MISSING_CREDENTIALS_LINK'|translate }}</a>
  </div>

  <div *ngIf="!loading && !loadError && !missingCredentials && displayBags.length === 0" class="text-muted">
    {{ (readonly ? 'SILO_BAGS.COMMITTED_EMPTY' : 'SILO_BAGS.EMPTY')|translate }}
  </div>

  <div class="btn-group silo-bag-viewmode" *ngIf="!loading && !loadError && !missingCredentials && displayBags.length > 0">
    <button type="button" class="btn btn-default btn-sm" [class.active]="viewMode === 'list'" (click)="setViewMode('list')">
      <i class="material-symbols-rounded">view_list</i> {{ 'SILO_BAGS.VIEW_MODE_LIST'|translate }}
    </button>
    <button type="button" class="btn btn-default btn-sm" [class.active]="viewMode === 'map'" (click)="setViewMode('map')">
      <i class="material-symbols-rounded">map</i> {{ 'SILO_BAGS.VIEW_MODE_MAP'|translate }}
    </button>
  </div>

  <div class="silo-bag-search" *ngIf="!loading && !loadError && !missingCredentials && displayBags.length > 0">
    <input type="text"
      class="form-control"
      [(ngModel)]="searchTerm"
      [placeholder]="'SILO_BAGS.SEARCH_PLACEHOLDER'|translate">
  </div>

  <div *ngIf="!loading && !loadError && displayBags.length > 0 && filteredDisplayBags.length === 0" class="text-muted search-no-results">
    {{ 'SILO_BAGS.SEARCH_NO_RESULTS'|translate }}
  </div>

  <table class="table table-condensed table-hover silo-bag-table" *ngIf="viewMode === 'list' && !loading && !loadError && filteredDisplayBags.length > 0">
    <thead>
      <tr class="tr-align-center">
        <th class="sap" *ngIf="!readonly"></th>
        <th class="sortable-header" (click)="sort('silo_id')">
          {{ 'SILO_BAGS.SILO_ID'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('silo_id')">{{ sortIcon('silo_id') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('silobag_name')">
          {{ 'SILO_BAGS.SILOBAG_NAME'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('silobag_name')">{{ sortIcon('silobag_name') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('lot_name')">
          {{ 'SILO_BAGS.LOT_NAME'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('lot_name')">{{ sortIcon('lot_name') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('countryside_name')">
          {{ 'SILO_BAGS.COUNTRYSIDE_NAME'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('countryside_name')">{{ sortIcon('countryside_name') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('grain_type')">
          {{ 'SILO_BAGS.GRAIN'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('grain_type')">{{ sortIcon('grain_type') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('bagged_weight')">
          {{ 'SILO_BAGS.WEIGHT'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('bagged_weight')">{{ sortIcon('bagged_weight') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('humidity')">
          {{ 'SILO_BAGS.HUMIDITY'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('humidity')">{{ sortIcon('humidity') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('bagged_date')">
          {{ 'SILO_BAGS.BAGGED_DATE'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('bagged_date')">{{ sortIcon('bagged_date') }}</i>
        </th>
        <th class="sortable-header" (click)="sort('days_since_bagging')">
          {{ 'SILO_BAGS.DAYS'|translate }}
          <i class="material-symbols-rounded sort-icon" [class.active]="isActiveSort('days_since_bagging')">{{ sortIcon('days_since_bagging') }}</i>
        </th>
        <th class="hidden-xs">{{ 'SILO_BAGS.LOCATION'|translate }}</th>
        <th *ngIf="showInsuredColumn">{{ 'SILO_BAGS.INSURANCE_COLUMN'|translate }}</th>
        <!-- Columna del toggle de historial: sólo para el dueño del grano (ver canViewHistory). -->
        <th class="sap" *ngIf="canViewHistory"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let bag of paginatedBags">
      <tr class="tr-align-center"
        [class.clickable]="!readonly"
        (click)="toggle(bag)"
        [class.tr-selected]="readonly || selected[bag.silo_id]">
        <td class="sap" *ngIf="!readonly">
          <input type="checkbox"
            [checked]="!!selected[bag.silo_id]"
            [disabled]="disabled"
            (click)="$event.stopPropagation(); toggle(bag)">
        </td>
        <td>
          <a [href]="silorealAppUrl + 'silobag/' + bag.silo_id"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()">
            <samp>{{ bag.silo_id }}</samp>
          </a>
          <span class="label label-success silo-bag-diff-badge" *ngIf="isNewlyProposed(bag)">
            {{ 'SILO_BAGS.DIFF_ADDED'|translate }}
          </span>
          <span class="label label-danger silo-bag-diff-badge" *ngIf="isRemovedFromBaseline(bag)">
            {{ 'SILO_BAGS.DIFF_REMOVED'|translate }}
          </span>
        </td>
        <td>{{ bag.silobag_name || '&#8212;' }}</td>
        <td>{{ bag.lot_name || '&#8212;' }}</td>
        <td>{{ bag.countryside_name || '&#8212;' }}</td>
        <td class="text-capitalize">{{ bag.grain_type }}</td>
        <td><b>{{ bag.bagged_weight|number:'1.0-2' }}</b> <small class="text-muted">tn</small></td>
        <td>{{ bag.humidity|number:'1.1-2' }} <small class="text-muted">%</small></td>
        <td>
          <ng-container *ngIf="baggedDateValue(bag) as baggedDate; else noBaggedDate">
            <date-md [date]="baggedDate" [style]="true"></date-md>
          </ng-container>
          <ng-template #noBaggedDate>&#8212;</ng-template>
        </td>
        <td>{{ bag.days_since_bagging }}</td>
        <td class="hidden-xs small text-muted">
          <ng-container *ngIf="hasCoordinates(bag)">
            <button type="button"
              class="btn btn-link btn-xs silo-bag-map-btn"
              [title]="'SILO_BAGS.VIEW_ON_MAP'|translate"
              (click)="focusOnMap(bag, $event)">
              <i class="material-symbols-rounded">location_on</i>
            </button>
          </ng-container>
          <span *ngIf="!hasCoordinates(bag)">&#8212;</span>
        </td>
        <td *ngIf="showInsuredColumn">
          <span class="label label-success"
            *ngIf="!insuredStatusLoading && !insuredStatusError && isInsured(bag)"
            [tooltip]="'SILO_BAGS.INSURED_TOOLTIP'|translate">
            {{ 'SILO_BAGS.INSURED_COLUMN'|translate }}
          </span>
          <a class="label label-info silo-bag-not-insured-badge"
            *ngIf="!insuredStatusLoading && !insuredStatusError && !isInsured(bag)"
            [href]="silorealAppUrl + 'silobag/insurance/' + bag.silo_id"
            target="_blank"
            rel="noopener noreferrer"
            [tooltip]="'SILO_BAGS.NOT_INSURED_TOOLTIP'|translate"
            (click)="$event.stopPropagation()">
            {{ 'SILO_BAGS.NOT_INSURED'|translate }}
          </a>
          <span class="text-muted" *ngIf="insuredStatusLoading">&#8230;</span>
          <span class="text-muted" *ngIf="insuredStatusError" [tooltip]="'SILO_BAGS.INSURED_STATUS_ERROR'|translate">&#8212;</span>
        </td>
        <td class="sap" *ngIf="canViewHistory">
          <button type="button"
            class="btn btn-link btn-xs silo-bag-history-btn"
            [title]="'SILO_BAGS.HISTORY_TOGGLE'|translate"
            [attr.aria-expanded]="isHistoryExpanded(bag)"
            (click)="toggleHistory(bag, $event)">
            <i class="material-symbols-rounded">{{ isHistoryExpanded(bag) ? 'expand_less' : 'history' }}</i>
          </button>
        </td>
      </tr>

      <!-- Fila expandible: trazabilidad de la bolsa (se pide al backend recién al abrir). -->
      <tr class="silo-bag-history-row" *ngIf="isHistoryExpanded(bag)">
        <td [attr.colspan]="historyColspan">
          <div class="silo-bag-history">
            <h5>{{ 'SILO_BAGS.HISTORY_TITLE'|translate }} <samp>{{ bag.silo_id }}</samp></h5>

            <div class="text-muted" *ngIf="isHistoryLoading(bag)">
              {{ 'SILO_BAGS.HISTORY_LOADING'|translate }}
            </div>

            <div class="text-danger" *ngIf="hasHistoryError(bag)">
              {{ 'SILO_BAGS.HISTORY_ERROR'|translate }}
              <button type="button" class="btn btn-link btn-xs" (click)="retryHistory(bag, $event)">
                {{ 'SILO_BAGS.HISTORY_RETRY'|translate }}
              </button>
            </div>

            <div class="text-muted" *ngIf="isHistoryEmpty(bag)">
              {{ 'SILO_BAGS.HISTORY_EMPTY'|translate }}
            </div>

            <ul class="silo-bag-history-list" *ngIf="!isHistoryLoading(bag) && !hasHistoryError(bag)">
              <li *ngFor="let event of historyEvents(bag)" [ngClass]="'action-' + event.action">
                <span class="history-date">{{ eventDate(event)|date:'dd/MM/yyyy HH:mm' }}</span>
                <span class="history-action">{{ actionLabel(event) }}</span>
                <span class="history-reason" *ngIf="reasonLabel(event)">&#8212; {{ reasonLabel(event) }}</span>
                <span class="history-actor text-muted">({{ actorLabel(event) }}<ng-container *ngIf="event.company">, {{ event.company }}</ng-container>)</span>
                <span class="history-reference" *ngIf="referenceLabel(event)">
                  <a *ngIf="orderLink(event) as link" [routerLink]="link">{{ referenceLabel(event) }}</a>
                  <samp *ngIf="!orderLink(event)">{{ referenceLabel(event) }}</samp>
                </span>
              </li>
            </ul>
          </div>
        </td>
      </tr>
      </ng-container>
    </tbody>
  </table>

  <!-- Se oculta en vez de destruirse para conservar zoom/pan. No depende de mapPoints.length. -->
  <div class="silo-bag-map-view" *ngIf="mapActivated && !loading && !loadError" [hidden]="viewMode !== 'map'">
    <div class="silo-bag-map-toolbar">
      <span class="text-muted" *ngIf="!readonly && !disabled">{{ 'SILO_BAGS.MAP_HINT'|translate }}</span>
      <span class="label label-success" *ngIf="!readonly">
        {{ 'SILO_BAGS.MAP_SELECTED_COUNT'|translate: { count: selectedBags.length, tons: (selectedTotal|number:'1.0-2') } }}
      </span>
    </div>

    <div class="alert alert-warning silo-bag-map-nogeo" *ngIf="bagsWithoutGeo > 0">
      {{ 'SILO_BAGS.MAP_NO_GEO'|translate: { count: bagsWithoutGeo } }}
      <a class="clickable" (click)="setViewMode('list')">{{ 'SILO_BAGS.MAP_NO_GEO_LINK'|translate }}</a>
    </div>

    <div class="text-muted search-no-results" *ngIf="mapPoints.length === 0 && bagsWithoutGeo === 0">
      {{ 'SILO_BAGS.MAP_EMPTY'|translate }}
    </div>

    <silobag-map [points]="mapPoints" height="420px" (select)="onMapSelect($event)"></silobag-map>

    <ul class="silo-bag-map-legend">
      <li *ngIf="!readonly"><span class="chip chip-selected"></span>{{ 'SILO_BAGS.MAP_LEGEND_SELECTED'|translate }}</li>
      <li *ngIf="!readonly"><span class="chip chip-unselected"></span>{{ 'SILO_BAGS.MAP_LEGEND_UNSELECTED'|translate }}</li>
      <li *ngIf="showsDiff"><span class="chip chip-removed"></span>{{ 'SILO_BAGS.MAP_LEGEND_REMOVED'|translate }}</li>
      <li *ngIf="readonly"><span class="chip chip-committed"></span>{{ 'SILO_BAGS.MAP_LEGEND_COMMITTED'|translate }}</li>
    </ul>
  </div>

  <div class="silo-bag-pagination" *ngIf="viewMode === 'list' && !loading && !loadError && totalPages > 1">
    <span class="pagination-info">
      {{ 'SILO_BAGS.PAGINATION_INFO' | translate: {
        from: (currentPage - 1) * pageSize + 1,
        to: currentPage * pageSize < filteredDisplayBags.length ? currentPage * pageSize : filteredDisplayBags.length,
        total: filteredDisplayBags.length
      } }}
    </span>
    <ul class="pagination pagination-sm">
      <li [class.disabled]="currentPage === 1">
        <a (click)="goToPage(currentPage - 1)">&laquo;</a>
      </li>
      <ng-container *ngFor="let p of pageNumbers">
        <li *ngIf="p !== -1" [class.active]="p === currentPage">
          <a (click)="goToPage(p)">{{ p }}</a>
        </li>
        <li *ngIf="p === -1" class="disabled">
          <a>…</a>
        </li>
      </ng-container>
      <li [class.disabled]="currentPage === totalPages">
        <a (click)="goToPage(currentPage + 1)">&raquo;</a>
      </li>
    </ul>
  </div>

  <!-- Resumen de lo seleccionado en ambas vistas. En lista + readonly se omite: la tabla ya muestra sólo las comprometidas. -->
  <div class="silo-bag-selected-summary"
    *ngIf="!loading && !loadError && selectedBags.length > 0 && (viewMode === 'map' || !readonly)">
    <h5>{{ (readonly ? 'SILO_BAGS.MAP_COMMITTED_LIST_TITLE' : 'SILO_BAGS.MAP_SELECTED_LIST_TITLE')|translate }} ({{ selectedBags.length }})</h5>
    <table class="table table-condensed table-hover">
      <thead>
        <tr>
          <th>{{ 'SILO_BAGS.SILO_ID'|translate }}</th>
          <th>{{ 'SILO_BAGS.SILOBAG_NAME'|translate }}</th>
          <th>{{ 'SILO_BAGS.LOT_NAME'|translate }}</th>
          <th>{{ 'SILO_BAGS.WEIGHT'|translate }}</th>
          <th class="sap" *ngIf="!readonly"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bag of selectedBags" [class.clickable]="viewMode === 'map'" (click)="focusSelectedOnMap(bag)">
          <td>
            <samp>{{ bag.silo_id }}</samp>
            <span class="label label-success silo-bag-diff-badge" *ngIf="isNewlyProposed(bag)">
              {{ 'SILO_BAGS.DIFF_ADDED'|translate }}
            </span>
          </td>
          <td>{{ bag.silobag_name || '&#8212;' }}</td>
          <td>{{ bag.lot_name || '&#8212;' }}</td>
          <td><b>{{ bag.bagged_weight|number:'1.0-2' }}</b> <small class="text-muted">tn</small></td>
          <td class="sap" *ngIf="!readonly">
            <button type="button"
              class="btn btn-link btn-xs silo-bag-remove-btn"
              [disabled]="disabled"
              [title]="'SILO_BAGS.MAP_REMOVE'|translate"
              (click)="removeSelected(bag, $event)">
              <i class="material-symbols-rounded">close</i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="silo-bag-totals" *ngIf="!loading && !loadError && displayBags.length > 0 && !readonly"
    [class.status-success]="hasValidCoverage"
    [class.status-danger]="!hasValidCoverage">
    <div class="row">
      <div class="col-sm-4">
        <small class="text-muted">{{ 'SILO_BAGS.SELECTED_TOTAL'|translate }}</small>
        <div><b>{{ selectedTotal|number:'1.0-2' }}</b> <small>tn</small></div>
      </div>
      <div class="col-sm-4">
        <small class="text-muted">{{ 'SILO_BAGS.ORDER_REQUIRED'|translate }}</small>
        <div>{{ orderQuantity|number:'1.0-0' }} <small>tn</small></div>
      </div>
      <div class="col-sm-4">
        <small class="text-muted">{{ 'SILO_BAGS.MIN_COVERAGE'|translate }} (+10%)</small>
        <div>{{ requiredCoverage|number:'1.0-2' }} <small>tn</small></div>
      </div>
    </div>
    <div class="silo-bag-status">
      <i class="material-symbols-rounded" *ngIf="hasValidCoverage">check_circle</i>
      <i class="material-symbols-rounded" *ngIf="!hasValidCoverage">error_outline</i>
      <span *ngIf="hasValidCoverage">{{ 'SILO_BAGS.COVERAGE_OK'|translate }}</span>
      <span *ngIf="!hasValidCoverage">{{ 'SILO_BAGS.COVERAGE_KO'|translate }}</span>
    </div>
    <div class="silo-bag-status silo-bag-excess" *ngIf="hasExcessCoverage">
      <i class="material-symbols-rounded">warning</i>
      <span>{{ 'SILO_BAGS.COVERAGE_EXCESS'|translate: { limit: (overCoverageLimit|number:'1.0-2') } }}</span>
    </div>
    <div class="silo-bag-changes-summary text-muted" *ngIf="siloBagChanges as changes">
      {{ 'SILO_BAGS.DIFF_SUMMARY'|translate: { kept: changes.kept, added: changes.added, removed: changes.removed } }}
    </div>
  </div>

  <div class="silo-bag-totals status-success" *ngIf="!loading && !loadError && readonly && displayBags.length > 0">
    <div class="row">
      <div class="col-sm-6">
        <small class="text-muted">{{ 'SILO_BAGS.COMMITTED_TOTAL'|translate }}</small>
        <div><b>{{ selectedTotal|number:'1.0-2' }}</b> <small>tn</small></div>
      </div>
      <div class="col-sm-6">
        <small class="text-muted">{{ 'SILO_BAGS.ORDER_REQUIRED'|translate }}</small>
        <div>{{ orderQuantity|number:'1.0-0' }} <small>tn</small></div>
      </div>
    </div>
  </div>
</div>
